<template>
  <div>
    <h1 class="mb-2 mt-1">Provider Data</h1>

    <category-summary-table
      category="provider"
      route-name="content"
      param-name="pid"
      name-label="Provider"
    >
      <template #title>
        UK Providers Ranking Table
      </template>
      <template #description>
        <p class="mb-2">
          Qualification for this table - a minimum of 5 products on our database open not more than 6 months ago. For all qualifying providers we have calculated an average score of products starting in the last 6 months. Providers that do not meet the minimum number of products but have been active in the last 12 months are also shown.
          <br><br>
          This table is derived from FVC's product scores and is not intended to be a definitive ranking of product providers whose products have been reviewed by FVC. You should take into account all appropriate and applicable factors when considering each product provider such as credit quality, reliability and suitability of their product range, administration and service levels.
        </p>
      </template>
    </category-summary-table>
  </div>
</template>

<script>
import CategorySummaryTable from '../CategorySummaryTable.vue'

export default {
  components: {
    CategorySummaryTable,
  },
}
</script>
